import type { GetExecutionResponse, GetVisualizationResponse } from '@blockworks/platform/api/research/studio';

import type { VisualizationParameterMeta } from '../../models';

type VisualizationWithExecution = Pick<GetVisualizationResponse<any>['data'], 'config'> & {
    execution: GetExecutionResponse['data'];
};

const makeParameterGroupMeta = ({ config }: VisualizationWithExecution) => {
    const { enabled, initialValue: savedInitialValue, excludes = [] } = config?.parameters?.groups ?? {};
    const views =
        config?.options?.groups?.map((group, idx) => {
            const { name = `Group ${idx + 1}` } = group;
            return { value: name, label: name };
        }) ?? [];

    // If there is only one view, it is the default
    const hasExistingDefault = views.some(view => view.value === savedInitialValue);
    const initialValue = hasExistingDefault ? savedInitialValue : views[0]?.value;

    return {
        id: 'groups',
        name: 'Parameter Groups',
        active: true,
        enabled: enabled,
        excludes,
        isStale: !hasExistingDefault && !!savedInitialValue,
        initialValue: initialValue,
        hidden: views.length <= 1,
        views,
    } satisfies VisualizationParameterMeta;
};

type ParameterGroupMeta = ReturnType<typeof makeParameterGroupMeta>;

export type { ParameterGroupMeta };
export { makeParameterGroupMeta };
